import europeanCountriesWithVAT from "../assets/js/european-countries-with-vat";

const state = {
  cart: {
    items: [],
    totalValue: 0,
    catalogId: ""
  }
};

const getters = {
  cart: state => {
    return state.cart;
  }
};

const actions = {
  addProduct({ commit, getters, rootGetters }, product) {
    const cart = getters.cart;
    const productIndex = cart.items.findIndex(p => p.productId === product._id);
    if (productIndex === -1) {
      commit("ADD_PRODUCT", { product, address: rootGetters.address });
    } else {
      commit("INCREMENT_PRODUCT", productIndex);
    }
    commit("INCREMENT_TOTAL_VALUE", product.p);
    if (europeanCountriesWithVAT.includes(rootGetters.address.countryCode)) {
      commit("CALCULATE_TOTAL_VALUE_WITH_VAT");
    }
  },

  addScaleProduct({ commit, rootGetters }, product) {
    const x =
      product.option === "totalPrice" && product.code.length !== 6
        ? Number(product.b.substring(6, 12))
        : Number(product.b.substring(7, 12));
    product = {
      ...product,
      itemPrice:
        product.option === "totalPrice"
          ? x
          : product.saleType === "unit" || product.unit === "1g"
          ? x * product.p
          : product.unit === "10g"
          ? Number(((x / 10) * product.p).toFixed(0))
          : product.unit === "100g"
          ? Number(((x / 100) * product.p).toFixed(0))
          : product.unit === "kg"
          ? Number(((x / 1000) * product.p).toFixed(0))
          : 0,
      quantity:
        product.option === "weightQty"
          ? x
          : product.saleType === "unit" || product.unit === "1g"
          ? Number((x / product.p).toFixed(0))
          : product.unit === "10g"
          ? Number(((x / product.p) * 10).toFixed(0))
          : product.unit === "100g"
          ? Number(((x / product.p) * 100).toFixed(0))
          : product.unit === "kg"
          ? Number(((x / product.p) * 1000).toFixed(0))
          : 0
    };
    commit("ADD_SCALE_PRODUCT", { product, address: rootGetters.address });
    commit("INCREMENT_TOTAL_VALUE", product.itemPrice);
    if (europeanCountriesWithVAT.includes(rootGetters.address.countryCode)) {
      commit("CALCULATE_TOTAL_VALUE_WITH_VAT");
    }
  },

  removeProduct({ commit, getters, rootGetters }, product) {
    const cart = getters.cart;
    const productIndex = cart.items.findIndex(p => p.productId === product._id);
    if (cart.items[productIndex].quantity === 1) {
      commit("REMOVE_PRODUCT", productIndex);
    } else {
      commit("DECREMENT_PRODUCT", productIndex);
    }
    commit("DECREMENT_TOTAL_VALUE", product.p);
    if (europeanCountriesWithVAT.includes(rootGetters.address.countryCode)) {
      commit("CALCULATE_TOTAL_VALUE_WITH_VAT");
    }
  },

  removeItem({ commit, getters, rootGetters }, product) {
    const cart = getters.cart;
    const productIndex = cart.items.findIndex(p => p.productId === product._id);
    const valueToDecrement = product.p * cart.items[productIndex].quantity;
    commit("REMOVE_PRODUCT", productIndex);
    commit("DECREMENT_TOTAL_VALUE", valueToDecrement);
    if (europeanCountriesWithVAT.includes(rootGetters.address.countryCode)) {
      commit("CALCULATE_TOTAL_VALUE_WITH_VAT");
    }
  },

  removeItemScale({ commit, getters, rootGetters }, barcode) {
    const cart = getters.cart;
    const productIndex = cart.items.findIndex(p => p.barcode === barcode);
    const valueToDecrement = cart.items[productIndex].itemPrice;
    commit("REMOVE_PRODUCT", productIndex);
    commit("DECREMENT_TOTAL_VALUE", valueToDecrement);
    if (europeanCountriesWithVAT.includes(rootGetters.address.countryCode)) {
      commit("CALCULATE_TOTAL_VALUE_WITH_VAT");
    }
  },

  emptyCart({ commit }) {
    commit("EMPTY_CART");
  }
};

const mutations = {
  ADD_PRODUCT(state, data) {
    const product = data.product;
    const address = data.address;

    const vat = !europeanCountriesWithVAT.includes(address.countryCode)
      ? undefined
      : !isNaN(data.product.vat)
      ? data.product.vat
      : !isNaN(data.shoppingAtStore.taxes.defaultVAT)
      ? data.shoppingAtStore.taxes.defaultVAT
      : 0;

    state.cart.items.push({
      productId: product._id,
      quantity: 1,
      price: product.p,
      barcode: product.b,
      name: product.n,
      imageURL: product.i,
      alcoholic: product.a || false,
      category: product.c,
      subcategory: product.s,
      scaleProduct: false,
      vat
    });
  },

  ADD_SCALE_PRODUCT(state, data) {
    const product = data.product;
    const address = data.address;

    const vat = !europeanCountriesWithVAT.includes(address.countryCode)
      ? undefined
      : !isNaN(data.product.vat)
      ? data.product.vat
      : !isNaN(data.shoppingAtStore.taxes.defaultVAT)
      ? data.shoppingAtStore.taxes.defaultVAT
      : 0;

    state.cart.items.push({
      quantity: product.quantity,
      price: product.p,
      itemPrice: product.itemPrice,
      barcode: product.b,
      code: product.code,
      saleType: product.saleType,
      option: product.option,
      unit: product.unit,
      name: product.n,
      alcoholic: product.a || false,
      category: product.c,
      subcategory: product.s,
      scaleProduct: true,
      vat
    });
  },

  REMOVE_PRODUCT(state, productIndex) {
    state.cart.items.splice(productIndex, 1);
  },

  INCREMENT_PRODUCT(state, productIndex) {
    state.cart.items[productIndex].quantity++;
  },

  DECREMENT_PRODUCT(state, productIndex) {
    state.cart.items[productIndex].quantity--;
  },

  INCREMENT_TOTAL_VALUE(state, value) {
    state.cart.totalValue += value;
    state.cart.totalValue = Number(state.cart.totalValue.toFixed(2));
  },

  DECREMENT_TOTAL_VALUE(state, value) {
    state.cart.totalValue -= value;
    state.cart.totalValue = Number(state.cart.totalValue.toFixed(2));
  },

  CALCULATE_TOTAL_VALUE_WITH_VAT(state) {
    state.cart.totalValue = 0;
    for (let i = 0; i < state.cart.items.length; i++) {
      if (typeof state.cart.items[i].vat === "number") {
        state.cart.totalValue +=
          state.cart.items[i].price *
          state.cart.items[i].quantity *
          (1 + state.cart.items[i].vat / 100);
      }
    }
    state.cart.totalValue = Number(state.cart.totalValue.toFixed(0));
  },

  EMPTY_CART(state) {
    state.cart.items = [];
    state.cart.totalValue = 0;
    state.cart.catalogId = null;
  },

  SET_CATALOG_ID(state, catalogId) {
    state.cart.catalogId = catalogId;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
